import { ArrowRight, ChevronRight } from "lucide-react";

const oldTools = [
  "SalesRabbit",
  "Field Routes",
  "Google Drive",
  "GoHighLevel",
  "Siro",
  "Virtual Assistants",
];

export default function ConsolidationSection() {
  return (
    <section className="py-28 bg-muted/30">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">
            Stop paying for 6 tools.{" "}
            <span className="text-[#3b82f6]">Use one.</span>
          </h2>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-10">
          {/* Old tools */}
          <div className="grid grid-cols-2 gap-2.5 shrink-0">
            {oldTools.map((tool) => (
              <div
                key={tool}
                className="flex items-center gap-2 rounded-lg border bg-card px-4 py-2.5 text-sm text-muted-foreground"
              >
                <span className="h-1.5 w-1.5 rounded-full bg-muted-foreground/40 shrink-0" />
                {tool}
              </div>
            ))}
          </div>

          {/* Arrow connector */}
          <div className="flex items-center gap-1 shrink-0 text-muted-foreground/40">
            <div className="hidden md:block w-8 h-px bg-border" />
            <ChevronRight className="h-5 w-5" />
            <ChevronRight className="h-5 w-5 -ml-3" />
            <div className="hidden md:block w-8 h-px bg-border" />
          </div>

          {/* AMPA */}
          <div className="rounded-xl border-2 border-[#3b82f6] bg-card px-10 py-8 text-center shrink-0 shadow-sm shadow-[#3b82f6]/10">
            <p className="text-2xl font-bold text-[#3b82f6]">
              AMPA Network
            </p>
            <p className="text-sm text-muted-foreground mt-1.5">
              Everything. One platform.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
